
import type { HitResultItem } from 'vue-instantsearch/vue3/es';

import type { TriggerViewItemListParameters } from '~~/types/integrations/tagManager/TagManagerIntegration';
import { EVENT_SOURCE } from '~~/constants/googleTagManager';

export default function (
  eventListItems: Maybe<HitResultItem[]>,
  additionalParameters: {
    searchTerm: Maybe<string>,
    currentSlug: Maybe<string>
  },
): { callViewItemListEvent: Function } {

  const { trackViewItemList } = useGtmEvents();
  const { getCurrentPageType } = usePageEventLocation();
  const {
    getters: {
      currentCategoryName,
    },
  } = useCategories();
  const getViewItemListEventData = (): TriggerViewItemListParameters => {

    const pageType = getCurrentPageType();
    const categoryName = currentCategoryName.value || '';
    const searchKey = additionalParameters.searchTerm || '';
    const missingIdIdentifier = 'no-id';

    const eventListIdGtm = pageType === EVENT_SOURCE.CATEGORY_LISTING
      ? additionalParameters.currentSlug || missingIdIdentifier
      : pageType || missingIdIdentifier;
    const eventListName = pageType === EVENT_SOURCE.CATEGORY_LISTING ? categoryName : searchKey;

    const viewItemListEventData: TriggerViewItemListParameters = {
      id: eventListIdGtm,
      name: eventListName,
      items: eventListItems || [],
    };

    return viewItemListEventData;
  
  };

  const callViewItemListEvent = () => {

    const viewItemListEventData = getViewItemListEventData();
    trackViewItemList(viewItemListEventData);
  
  };

  return { callViewItemListEvent };

}
